<div *ngIf="listingSettings.ListingCategory.Visible">
  <label class="control-label">{{ listingSettings.ListingCategory.LabelText }}</label>
  <select disabled class="form-control"></select>
</div>

<div *ngIf="listingSettings.ListingSubCategory.Visible">
  <label class="control-label">{{ listingSettings.ListingSubCategory.LabelText }}</label>
  <select disabled class="form-control"></select>
</div>

<div *ngIf="listingSettings.LongDescription.Visible">
  <label class="control-label">{{ listingSettings.LongDescription.LabelText }}</label>
  <input disabled type="text" class="form-control" />
</div>

<div *ngIf="listingSettings.ShortDescription.Visible">
  <label class="control-label">{{ listingSettings.ShortDescription.LabelText }}</label>
  <input disabled type="text" class="form-control" />
</div>

<div *ngIf="listingSettings.Keywords.Visible">
  <label class="control-label">{{ listingSettings.Keywords.LabelText }}</label>
  <input disabled type="text" class="form-control" />
</div>
